import { View } from "react-native";

import { signInMethods } from "@/session/signInMethods";
import type { SignInMethod } from "@/session/types";
import { Text } from "@/ui/Text";

import { ProductHeader } from "./header/ProductHeader";
import { useScreenStyles } from "./screenStyles";

type Props = {
  /** Defaults to the app's list (empty in 001; 002 adds email + password). */
  methods?: readonly SignInMethod[];
};

/**
 * Signed-out entry (FR-002, FR-011; P-AUTH-4; US1-1): the product header, then each sign-in method in
 * order, or "Sign-in is coming soon" while there are none.
 */
export function EntryScreen({ methods = signInMethods }: Props) {
  const styles = useScreenStyles();
  return (
    <View style={styles.screen} testID="entry-screen">
      <ProductHeader />
      <View style={styles.body} role="main">
        <Text variant="heading" accessibilityRole="header" aria-level={1}>
          Welcome to Akaiva Edu Power
        </Text>
        {methods.length === 0 ? (
          <Text tone="muted" style={styles.message}>
            Sign-in is coming soon
          </Text>
        ) : (
          methods.map(({ id, EntryComponent }) => <EntryComponent key={id} />)
        )}
      </View>
    </View>
  );
}
